// import moment from 'moment'
export default [
    {
        text: 'Código',
        sortable: false,
        value: 'code',
    },
    {
        text: 'Glosa',
        sortable: false,
        value: 'comment',
    },
    {
        text: 'Tipo Código',
        sortable: false,
        value: 'accountTypeCode',
    },
    {
        text: 'Tipo Glosa',
        sortable: false,
        value: 'accountTypeComment',
    },
    // {
    //     text: 'Tipo Código',
    //     fieldType: 'computed',
    //     computed: ({ acc_account_type }) => {
    //         if (acc_account_type) return acc_account_type.code
    //         else return '-'
    //     },
    //     sortable: false,
    // },
    // {
    //     text: 'Tipo Glosa',
    //     fieldType: 'computed',
    //     computed: ({ acc_account_type }) => {
    //         if (acc_account_type) return acc_account_type.comment
    //         else return '-'
    //     },
    //     sortable: false,
    // },
    // {
    //     text: 'Año',
    //     sortable: false,
    //     value: 'year',
    // },
    // {
    //     text: 'Estado',
    //     fieldType: 'computed',
    //     computed: ({ reviewed_at }) => {
    //         if(reviewed_at) return 'Revisado'
    //         else return '-'
    //     },
    //     sortable: false,
    // },
]
